import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'regex',
	standalone: true,
})
export class RegexPipe implements PipeTransform {
	transform(value: string, pattern: string | RegExp, flags?: string): RegExpMatchArray | null {
		if (typeof pattern === 'string') {
			return value.match(new RegExp(pattern, flags));
		} else {
			return value.match(pattern);
		}
	}
}
